<ng-template #addNewReferent let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h3>{{ "MODAL.EDIT_REFERENT" | translate }}</h3>
    <div class="row" [formGroup]="formGroup">
      <div class="col-lg-6 col-12 form-group">
        <label for="client-add" class="col-form-label">{{ "COMPANY" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          [formControlName]="'client'"
          id="client-add"
          bindLabel="name"
          bindValue="id"
          class="{{ fieldHasErrors('client') ? 'is-invalid' : '' }}"
          [searchable]="true"
          [closeOnSelect]="true"
          [clearable]="false"
          (change)="filterAddresses()"
          [items]="customerService.customersList"
          [openOnEnter]="false"
          [virtualScroll]="true"
        >
        </ng-select>
        <div class="invalid-feedback" *ngIf="formGroup.controls.client.errors?.required">
          {{ "ERRORS.FIELD_COMPANY" | translate }}
        </div>
      </div>
      <div class="col-lg-6 col-12 form-group">
        <label for="label-add" class="col-form-label">{{ "OFFICE_SITE" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          [formControlName]="'site'"
          [readonly]="addressesList.length < 1"
          id="label-add"
          bindLabel="label"
          bindValue="id"
          [searchable]="true"
          [closeOnSelect]="true"
          [clearable]="false"
          class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
          [items]="addressesList"
          [openOnEnter]="false"
          [virtualScroll]="true"
        >
        </ng-select>
        <div class="invalid-feedback" *ngIf="formGroup.controls.site.errors?.required">
          {{ "ERRORS.FIELD_OFFICE_SITE" | translate }}
        </div>
      </div>
      <div class="col-lg-6 col-12 form-group">
        <label for="name-add" class="col-form-label">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
        <input type="text" id="name-add" name="name-add" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" formControlName="firstname" />
        <div class="invalid-feedback" *ngIf="formGroup.controls.firstname.errors?.required">{{ "ERRORS.FIELD_NAME" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls.firstname.errors?.required">{{ "ERRORS.FIELD_NAME" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
      </div>
      <div class="col-lg-6 col-12 form-group">
        <label for="surname-add" class="col-form-label">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
        <input type="text" id="surname-add" name="surname-add" class="form-control {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" formControlName="lastname" />
        <div class="invalid-feedback" *ngIf="formGroup.controls.lastname.errors?.required">{{ "ERRORS.FIELD_SURNAME" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
      </div>
      <div class="col-lg-6 col-12 form-group">
        <label for="email-add" class="col-form-label">{{ "EMAIL" | translate }}<sup class="text-danger">*</sup></label>
        <input type="text" id="email-add" name="email-add" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" formControlName="email" />
        <div class="invalid-feedback" *ngIf="formGroup.controls.email.errors?.required">{{ "ERRORS.INSERT_EMAIL" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.email?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.email?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroup.controls?.email?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
      </div>
      <div class="col-lg-6 col-12 form-group">
        <label for="phone-add" class="col-form-label">{{ "PHONE" | translate }}</label>
        <input type="text" id="phone-add" maxlength="15" name="phone-add" class="form-control" formControlName="phone" />
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-start">
    <button type="submit" class="btn btn-primary" (click)="edit()">{{ "EDIT" | translate }}</button>
  </div>
</ng-template>
